import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";
import Slideshow from "../../assets/Slideshow/Slideshow";
import "./PersonalProjects.css";

import branding1 from "../../assets/Images/brandingpics/1.png"
import branding2 from "../../assets/Images/brandingpics/2.png"
import branding3 from "../../assets/Images/brandingpics/3.png"
import branding4 from "../../assets/Images/brandingpics/4.mp4"


const Branding = () => {
  // Add visuals later:
  // - brand guide pages (first exploration)
  // - mockups (first + later explorations)
  // - logo sketches + refined versions (later exploration)
  // - posters (later exploration)
  // - concept / mood boards
  // - color palette explorations
  // - typography tests
  const images = [branding1,branding2,branding3,branding4];

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="page-container">
      <Navbar />

      <div className="content-lo1-headings">
        <h1>Branding</h1>
        <p>
          An ongoing space where I practice branding turning ideas into visual
          identity systems that feel consistent and real.
        </p>
      </div>

      <div className="line"></div>

      <div className="breadcrumb-wrap" style={{ padding: "0.1rem 7.5rem" }}>
        <BreadcrumbHeader />
      </div>

      <div className="content-lo1">
        <div className="pp-layout">
          {/* LEFT */}
          <div className="pp-left">
            {/* Anchor navigation */}
            <div className="pp-anchors">
              <button onClick={() => scrollToId("approach")}>Approach</button>
              <button onClick={() => scrollToId("system")}>
                From idea to system
              </button>
              <button onClick={() => scrollToId("learning")}>
                What I’m learning
              </button>
            </div>

            {/* APPROACH */}
            <section id="approach" className="pp-section">
              <h2>Branding as a Practice</h2>
              <p>
                I don’t really see branding as something that gets finished.
                It’s a skill I keep practicing, and it naturally shows up in
                many things I work on posters, UI, campaigns, and even how I
                design this portfolio.
              </p>
              <p>
                The first time I worked with branding, I focused on understanding
                structure. I created a simple brand guide and used mockups to see
                how an identity could stay consistent across different outputs.
              </p>
              <p>
                In later work, branding became more practical. I worked on logo
                design, posters, and more detailed mockups, where everything
                needed to feel connected. That made branding feel less like
                separate assets and more like one visual language.
              </p>
            </section>

            {/* SYSTEM */}
            <section id="system" className="pp-section">
              <h2>From Idea to System</h2>
              <p>
                I usually start with the idea first. What does the brand stand
                for, who is it for, and how should it feel? From there, I
                translate that direction into visual choices that can be reused
                and applied consistently.
              </p>

              <ul>
                <li>
                  <b>Logo direction:</b> sketching, selecting a direction, 
                  refining, building variations (icon, wordmark, lockups)
                </li>
                <li>
                  <b>Color & typography:</b> testing combinations until the tone
                  feels right
                </li>
                <li>
                  <b>Mockups:</b> applying the identity to real situations
                  (posters, web, socials) to see if it holds together
                </li>
                <li>
                  <b>Mini brand guide:</b> documenting simple rules to keep
                  things consistent
                </li>
              </ul>

              <div className="pp-snapshot">
                <div className="pp-snapshot-item">
                  <span className="pp-label">Focus</span>
                  <span className="pp-value">
                    Identity, consistency, visual storytelling
                  </span>
                </div>
                <div className="pp-snapshot-item">
                  <span className="pp-label">Deliverables</span>
                  <span className="pp-value">
                    Brand guides, logos, posters, mockups, concept boards
                  </span>
                </div>
                <div className="pp-snapshot-item">
                  <span className="pp-label">Tools</span>
                  <span className="pp-value">
                    Figma, Illustrator, Photoshop
                  </span>
                </div>
              </div>
            </section>

            {/* LEARNING */}
            <section id="learning" className="pp-section">
              <h2>What I Keep Learning</h2>
              <p>
                Working on branding keeps reminding me that strong identities
                come from clear choices and consistency, not from adding more
                elements.
              </p>

              <ul>
                <li>How to turn loose ideas into clear visual directions</li>
                <li>How repetition helps designs feel intentional</li>
                <li>Why brand guides are useful when projects grow</li>
                <li>How mockups quickly show what doesn’t work</li>
                <li>How simple rules make designs easier to apply</li>
              </ul>

              <p>
                Each branding exercise helped me get better at deciding what to
                include, what to simplify, and what needs to stay the same across
                different formats.
              </p>
            </section>
          </div>

          {/* RIGHT */}
          <aside className="pp-right">
            {images.length > 0 ? (
              <Slideshow images={images} />
            ) : (
              <div className="slideshow-placeholder">
                <p>Slideshow Placeholder</p>
                <p>Add images to the images array to display slideshow</p>
              </div>
            )}

            <div className="pp-caption">
              <p>
                
              </p>
            </div>
          </aside>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Branding;
